import { IGenericTableData } from '@/interfaces/powerMarkets/table/IGenericTableData.ts';
import { ISubscriptionSettings } from '@/interfaces/powerMarkets/notifications/ISubscriptionSettings.ts';
import { ApiPromise, useApi } from '@/api/useApi.ts';

const staticApiCall = useApi('static');

function getLiveTableNotifications (userId: string): ApiPromise<IGenericTableData> {
    return staticApiCall.get<IGenericTableData>({
        endpoint: `/LiveTable_Notifications/${userId}`,
    });
}

function postSubscriptionSettings (subscriptions: Array<ISubscriptionSettings>): ApiPromise<void> {
    return staticApiCall.post<{ subscriptions: Array<ISubscriptionSettings> }, void>({
        endpoint: '/userOnline/newSubscriptions',
        payload: { subscriptions },
    });
}

function markNotificationsAsSeen (): ApiPromise<void> {
    return staticApiCall.get<void>({
        endpoint: '/NotificationSeen',
    });
}

export const notificationsApi = {
    getLiveTableNotifications,
    postSubscriptionSettings,
    markNotificationsAsSeen,
};
